import { Icon } from '@studio/design-system/icon';
import type { HtmlAttributes, HtmlAttributesWithChildren } from '@studio/design-system/props';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Exhibit } from './styled.jsx';

const icons = [
  'add',
  'alert-circle',
  'alert-octagon',
  'alert-triangle',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'audio-slash',
  'audio',
  'auto-tracking',
  'bridge',
  'bomb',
  'camera-add',
  'camera-slash',
  'camera',
  'check',
  'chevron-down',
  'chevron-up',
  'click-center',
  'close',
  'discovery',
  'download-circle',
  'download-cloud',
  'dpad-down',
  'dpad-left',
  'dpad-right',
  'dpad-up',
  'edit',
  'eye-slash',
  'eye',
  'fast-frame',
  'file',
  'gamepad-b0',
  'gamepad-b1',
  'gamepad-b2',
  'gamepad-b3',
  'gamepad-b4',
  'gamepad-b5',
  'gamepad-b6',
  'gamepad-b7',
  'gamepad-b8',
  'grid',
  'group',
  'headphone-slash',
  'headphone',
  'home',
  'info-alt',
  'info',
  'internet-slash',
  'internet',
  'joystick',
  'ken-burns',
  'l-stick-x',
  'l-stick-y',
  'l-stick-z',
  'link',
  'menu',
  'minus',
  'monitoring',
  'move-slash',
  'move',
  'notification',
  'overflow',
  'plus',
  'pointer',
  'power',
  'preset-image',
  'preset-position',
  'r-stick-x',
  'r-stick-y',
  'r-stick-z',
  'reboot',
  'remove',
  'reset',
  'room',
  'search',
  'settings',
  'sleep',
  'sliders',
  'source',
  'spinner',
  'success-circle',
  'success-cloud',
  'tally-light',
  'target',
  'teammate',
  'tracking',
  'trash',
  'zoom-in',
  'zoom-out'
];

const Box = ({ children, className, ...props }: HtmlAttributesWithChildren): ReactElement => (
  <div className={twMerge('rounded border border-foreground/25 p-8', className)} {...props}>
    {children}
  </div>
);

const Specimen = ({ className, ...props }: HtmlAttributes): ReactElement => (
  <div className={twMerge('mt-16 flex w-[500px] flex-wrap gap-8', className)} {...props}>
    {icons.map((µ) => (
      <Box key={µ}>
        <Icon className={µ === 'spinner' ? 'animate-spin' : undefined} icon={µ} title={µ} />
      </Box>
    ))}
  </div>
);

/** `<Icons>` exhibit. */
export const Icons = (): ReactElement => (
  <Exhibit title='Icons'>
    <div className='flex flex-col gap-40'>
      {[
        ['40px', 'text-3xl'],
        ['32px', 'text-2xl'],
        ['24px', 'text-xl'],
        ['18px', 'text-lg'],
        ['16px', 'text-base'],
        ['14px', 'text-md'],
        ['12px', 'text-sm']
      ].map(([label, clazz]) => (
        <div key={label}>
          <div className='text-center text-lg font-bold'>{label}</div>
          <Specimen className={clazz} />
        </div>
      ))}
    </div>
  </Exhibit>
);
